import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

// PrimeNG components
import { ButtonModule } from 'primeng/button';
import { TableModule } from 'primeng/table';
import { InputTextModule } from 'primeng/inputtext';
import { ToastModule } from 'primeng/toast';
import { DialogModule } from 'primeng/dialog';
import { CardModule } from 'primeng/card';
import { FieldsetModule } from 'primeng/fieldset';
import { DropdownModule } from 'primeng/dropdown';
import { RadioButtonModule } from 'primeng/radiobutton';
import { TextareaModule } from 'primeng/textarea';
import { PasswordModule } from 'primeng/password';
import { SelectModule } from 'primeng/select';
import { MenuModule } from 'primeng/menu';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { ProgressBarModule } from 'primeng/progressbar';
import { DividerModule } from 'primeng/divider';
import { ListboxModule } from 'primeng/listbox';
import { TooltipModule } from 'primeng/tooltip';
import { CheckboxModule } from 'primeng/checkbox';
import { TabViewModule } from 'primeng/tabview';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { TagModule } from 'primeng/tag';
import { InputNumberModule } from 'primeng/inputnumber';
import { InputSwitchModule } from 'primeng/inputswitch';
import { MultiSelectModule } from 'primeng/multiselect';


@NgModule({ 

  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,

    // PrimeNG components
    ButtonModule,
    TableModule,
    InputTextModule,
    ToastModule,
    DialogModule,
    CardModule,
    FieldsetModule,
    DropdownModule,
    RadioButtonModule,
    TextareaModule,
    PasswordModule,
    SelectModule,
    MenuModule,
    ProgressSpinnerModule,
    ProgressBarModule,
    DividerModule,
    ListboxModule,
    TooltipModule,
    CheckboxModule,
    TabViewModule,
    ConfirmDialogModule,
    TagModule,
    InputNumberModule,
    InputSwitchModule,
    MultiSelectModule
    
    

  ],
  exports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,

    // PrimeNG components
    ButtonModule,
    TableModule,
    InputTextModule,
    ToastModule,
    DialogModule,
    CardModule,
    FieldsetModule,
    DropdownModule,
    RadioButtonModule,
    TextareaModule,
    PasswordModule,
    SelectModule,
    MenuModule,
    ProgressSpinnerModule,
    ProgressBarModule,
    DividerModule,
    ListboxModule,
    TooltipModule,
    CheckboxModule,
    TabViewModule,
    ConfirmDialogModule,
    TagModule,
    InputNumberModule,
    InputSwitchModule,
    MultiSelectModule


  ]
})
export class SharedModule { }
